import { Link } from "react-router-dom";
import { ASSETS, BUY_URL, CONTRACT_ADDRESS, DEXSCREENER_URL, X_URL } from "@/config";

const COLUMNS = [
  {
    title: "SYSTEM",
    links: [
      { to: "/network", label: "Network" },
      { to: "/agents", label: "AI Agents" },
      { to: "/machines", label: "Machine Registry" },
      { to: "/tasks", label: "Task Market" },
    ],
  },
  {
    title: "PROTOCOL",
    links: [
      { to: "/economy", label: "Machine Economy" },
      { to: "/terminal", label: "Terminal" },
      { to: "/thesis", label: "Thesis" },
      { to: "/docs", label: "Documentation" },
    ],
  },
  {
    title: "PROJECT",
    links: [
      { to: "/about", label: "About" },
      { to: "/launch", label: "Launch" },
      { href: X_URL, label: "X / @ARCMECH" },
      { href: BUY_URL, label: "Buy on Argus" },
    ],
  },
];

const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-arc-blue/15 bg-arc-navy/60 grid-bg">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={ASSETS.logo} alt="ARCMECH" className="h-12 w-auto mb-5" />
          <p className="font-display text-sm tracking-[0.2em] text-arc-white uppercase">The Autonomous Machine Economy</p>
          <p className="mt-3 text-sm text-arc-silver/60 max-w-sm leading-relaxed">
            Machines That Think. Machines That Transact. AI agents, robotics and programmable economic infrastructure on ARC.
          </p>
          <div className="mt-5 font-mono text-[11px] tracking-[0.2em] text-arc-silver/50 space-y-1.5">
            <div>SYSTEM STATUS <span className="text-arc-green ml-2">● ONLINE</span></div>
            <div>CONTRACT <span className="text-arc-cyan ml-2 break-all">{CONTRACT_ADDRESS.slice(0, 6)}…{CONTRACT_ADDRESS.slice(-4)}</span></div>
            <div>NETWORK <span className="text-arc-silver ml-2">ARC</span></div>
          </div>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <div className="font-mono text-[10px] tracking-[0.35em] text-arc-electric mb-4">{col.title}</div>
            <ul className="space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} data-cursor="OPEN" className="text-sm text-arc-silver/60 hover:text-arc-cyan transition-colors">{l.label}</Link>
                  ) : (
                    <a href={l.href} target="_blank" rel="noopener noreferrer" data-cursor="OPEN" className="text-sm text-arc-silver/60 hover:text-arc-cyan transition-colors">{l.label}</a>
                  )}
                </li>
              ))}
              {col.title === "PROJECT" && (
                <li>
                  <a href={DEXSCREENER_URL} target="_blank" rel="noopener noreferrer" data-cursor="OPEN" className="text-sm text-arc-silver/60 hover:text-arc-cyan transition-colors">Chart / DexScreener</a>
                </li>
              )}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-12 pt-6 border-t border-arc-blue/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="font-mono text-[11px] tracking-[0.2em] text-arc-silver/40">© 2026 ARCMECH</div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-arc-silver/30">
          INTERFACE TELEMETRY IS SIMULATED · NO ON-CHAIN METRICS DISPLAYED
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
